module.exports = __webpack_public_path__ + "assets/96c0612e5d54482b0759ad9f3e4a72c2.mp3";